import bgCard1 from '../assets/img/card-field-service-engineers.webp';
import bgCard2 from '../assets/img/card-monteurs-technische-dienst.png';
import bgCard3 from '../assets/img/operators.webp';
import bgCard4 from '../assets/img/card-software-electrical-engineers.png';
import bgCard5 from '../assets/img/card-mechanical-engineers.png';
import bgCard6 from '../assets/img/card-machinebouwers.png';
import bgCard7 from '../assets/img/card-installatietechniek.png';

const cards = [
  {
    title: '(Field) Service Engineers',
    href: '#!',
    bgImage: bgCard1,
    icon: 'wind-turbine'
  },
  {
    title: 'Monteurs Technische Dienst',
    href: '#!',
    bgImage: bgCard2,
    icon: 'conveyor-belt'
  },
  {
    title: 'Operators',
    href: '#!',
    bgImage: bgCard3,
    icon: 'joystick'
  },
  {
    title: 'Software & Electrical Engineers',
    href: '#!',
    bgImage: bgCard4,
    icon: 'code'
  },
  {
    title: 'Mechanical Engineers',
    href: '#!',
    bgImage: bgCard5,
    icon: 'plug'
  },
  {
    title: 'Machinebouwers',
    href: '#!',
    bgImage: bgCard6,
    icon: 'gear'
  },
  {
    title: 'Installatietechniek',
    href: '#!',
    bgImage: bgCard7,
    icon: 'plug'
  }
];
export const cards2 = [
  {
    title: '(Field) Service Engineers',
    href: '#!',
    bgImage: bgCard1,
    icon: 'wind-turbine',
    badge: '567 vacatures'
  },
  {
    title: 'Mechanical Engineers',
    href: '#!',
    bgImage: bgCard5,
    icon: 'plug',
    badge: '909 vacatures'
  },
  {
    title: 'Software & Electrical Engineers',
    href: '#!',
    bgImage: bgCard4,
    icon: 'code',
    badge: '808 vacatures'
  },
  {
    title: 'Monteurs Technische Dienst',
    href: '#!',
    bgImage: bgCard2,
    icon: 'conveyor-belt',
    badge: '799 vacatures'
  },
  {
    title: 'Machinebouwers',
    href: '#!',
    bgImage: bgCard6,
    icon: 'gear',
    badge: '557 vacatures'
  }
];
export default cards;
